// import React, { useState } from 'react';
// import api from '../../../api/axiosConfig';
// import { Link, useNavigate } from 'react-router-dom';
// import '../../../styles/forms.css';
// import Navbar from '../homePage/Navbar';
// // import TopBar from '../homePage/TopBar';
// import PersonIcon from '@mui/icons-material/Person';
// import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
// import VaccinesIcon from '@mui/icons-material/Vaccines';
// import BiotechIcon from '@mui/icons-material/Biotech';
// import CorporateFareIcon from '@mui/icons-material/CorporateFare';
// import StorefrontIcon from '@mui/icons-material/Storefront';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
// import gps from '../../assets/gps.png'

// const roles = ["lab"];
// // const roles = ["doctor", "hospital",  "organisation", "Animal Enthusiasts"];

// const Register: React.FC = () => {
//   const navigate = useNavigate();
//   const [showPassword, setShowPassword] = useState(false);
//   const [accountType, setAccountType] = useState<'Service' | 'Animal Owner'>('Animal Owner');
//   const [toast, setToast] = useState<{ type: 'success' | 'error'; message: string } | null>(null);
//   const [formErrors, setFormErrors] = useState<Record<string, string>>({});
//   const [showPasswordRules, setShowPasswordRules] = useState(false);

//   const [passwordChecks, setPasswordChecks] = useState({
//     length: false,
//     numbers: false,
//     special: false
//   });




//   const initialFormState = {
//     user_name: '',
//     user_email: '',
//     user_password: '',
//     user_role: '',
//     user_phone: '',
//     city: '',
//     govt_id_image: null as File | null,
//     owner_name: '',
//     owner_password: '',
//     owner_phone: '',
//     owner_city: '',
//     gst_number:''
//   };

//   const [form, setForm] = useState(initialFormState);
//   // setForm(initialFormState);


//   // const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//   //   if (e.target.files?.length) {
//   //     setForm({ ...form, govt_id_image: e.target.files[0] });
//   //   }
//   // };


//   const checkPasswordStrength = (password: string) => {
//     const hasLength = password.length >= 8;
//     const numberCount = (password.match(/\d/g) || []).length;
//     const hasTwoNumbers = numberCount >= 2;
//     const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);

//     // const allPassed = hasLength && hasTwoNumbers && hasSpecial;

//     setPasswordChecks({
//       length: hasLength,
//       numbers: hasTwoNumbers,
//       special: hasSpecial
//     });

//     // auto-hide if all satisfied
//     // if (allPassed) {
//     //   setShowPasswordRules(false);
//     // }
//   };




//   const validateForm = (): boolean => {
//     const errors: Record<string, string> = {};

//     if (accountType === 'Service') {
//       if (!form.user_name?.trim()) errors.user_name = 'Name is required';
//       if (!form.user_password?.trim()) errors.user_password = 'Password is required';
//       if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(form.user_email)) errors.user_email = 'Invalid email format';
//       if (!/^\d{10}$/.test(form.user_phone)) errors.user_phone = 'Phone Number must be a 10 digit number';
//       if (!form.city?.trim()) errors.city = 'City is required';

//       if (!passwordChecks.length || !passwordChecks.numbers || !passwordChecks.special) {
//         errors.user_password = 'Password must satisfy all strength rules';
//       }


//       if (form.user_role === 'doctor') {
//         if (!form.govt_id_image) errors.govt_id_image = 'Government ID image is required';
//       }

//     } else if (accountType === 'Animal Owner') {
//       if (!form.owner_name?.trim()) errors.owner_name = 'Name is required';
//       if (!form.owner_password?.trim()) errors.owner_password = 'Password is required';
//       else if (form.owner_password.length < 8) errors.owner_password = 'Password must be 8 or more characters';
//       if (!/^\d{10}$/.test(form.owner_phone)) errors.owner_phone = 'Phone must be a 10 digit number';
//       if (!form.owner_city?.trim()) errors.owner_city = 'City is required';
//     }

//     setFormErrors(errors);

//     return Object.keys(errors).length === 0;
//   };


//   const handleRegister = async () => {
//     try {
//       const isValid = validateForm();
//       if (!isValid) return;

//       if (accountType === 'Service') {
//         const formData = new FormData();
//         Object.entries(form).forEach(([key, value]) => {
//           if (
//             value !== null &&
//             (
//               key.startsWith('user_') ||
//               ['govt_id', 'specialization', 'gst_number', 'govt_id_image', 'city',].includes(key)
//             )
//           ) {
//             formData.append(key, value as string | Blob);
//           }
//         });

//         await api.auth_api.post('/auth/register', formData, {
//           headers: { 'Content-Type': 'multipart/form-data' }
//         });

//         setToast({ type: 'success', message: 'Registered successfully!' });
//         setTimeout(() => navigate('/login'), 1500);
//       } else {
//         await api.auth_api.post('/auth/registerAnimal', {
//           owner_name: form.owner_name,
//           owner_password: form.owner_password,
//           owner_phone: form.owner_phone,
//           owner_city: form.owner_city,
//           owner_role: 'owner'
//         });

//         setToast({ type: 'success', message: 'owner Registered!' });
//         setTimeout(() => navigate('/login'), 1500);
//       }

//       setForm(initialFormState);
//       setShowPasswordRules(false);
//       setPasswordChecks({
//         length: false,
//         numbers: false,
//         special: false
//       });
//     } catch (error) {
//       setToast({ type: 'error', message: 'Registration failed. Please try again.' });
//     } finally {
//       setTimeout(() => setToast(null), 5000); // auto-close after 5s
//     }
//   };
  

//   const handleLocationClick = () => {
//   if (!navigator.geolocation) {
//     alert("Geolocation is not supported by your browser.");
//     return;
//   }

//   navigator.geolocation.getCurrentPosition(
//     async (position) => {
//       const { latitude, longitude } = position.coords;
//       try {
//         const res = await fetch(
//           `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
//         );
//         const data = await res.json();
//         const address = data.address;

//         if (accountType === "Animal Owner") {
//           setForm((prev) => ({
//             ...prev,
//             city: address.city || address.town || address.village || "",
//           }));
//         } else {
//           setForm((prev) => ({
//             ...prev,
//             owner_city: address.city || address.town || address.village || "",
//           }));
//         }
//       } catch (err) {
//         console.error("Reverse geocoding failed:", err);
//         alert("Could not retrieve location details.");
//       }
//     },
//     (err) => {
//       console.error("Geolocation error:", err);
//       alert("Permission denied or location unavailable.");
//     }
//   );
// };








//   return (
//     <>
//       {/* <TopBar /> */}
//       <Navbar />

//       {toast && (
//         <div className={`global-toast ${toast.type}`}>
//           <span>{toast.message}</span>
//           <button
//             className="toast-close"
//             onClick={() => setToast(null)}
//             aria-label="Close"
//           >
//             ×
//           </button>
//         </div>
//       )}

//       <div className="center-page-lr">
//         <div className="form-container">
//           <h2 className="form-title">Register</h2>

//           {/* Account Type Selection */}
//           <div className="form-group animated-toggle">
//             {['Animal Owner', 'Service'].map((type) => (
//               <div
//                 key={type}
//                 className={`toggle-tile ${accountType === type ? 'active' : ''}`}
//                 onClick={() => setAccountType(type as 'Service' | 'Animal Owner')}
//               >
//                 {type === 'Service' ? 'Service' : 'Animal Owner'}
//               </div>
//             ))}
//           </div>





//           {/* User Registration Form */}
//           {accountType === 'Service' && (
//             <>
//               {/* Role Selection */}
//               <div className="form-group creative-role-grid">
//                 {roles.map((role) => (
//                   <div
//                     key={role}
//                     className={`creative-card ${form.user_role === role ? 'active' : ''}`}
//                     onClick={() => setForm({ ...form, user_role: role })}
//                   >
//                     <div className="creative-icon">
//                       {role === "doctor" ? (
//                         <PersonIcon />
//                       ) : role === "hospital" ? (
//                         <LocalHospitalIcon />
//                       ) : role === "pharmacy" ? (
//                         <VaccinesIcon />
//                       ) : role === "lab" ? (
//                         <BiotechIcon />
//                       ) : role === "organisation" ? (
//                         <CorporateFareIcon />
//                       ) : role === "vendor" ? (
//                         <StorefrontIcon />
//                       ) : (
//                         <PersonIcon />
//                       )}
//                     </div>
//                     &nbsp;
//                     &nbsp;
//                     <span>{role.charAt(0).toUpperCase() + role.slice(1)}</span>
//                   </div>
//                 ))}
//               </div>

//               <div className="form-grid">
//                 <div className="form-group">
//                   <input
//                     className={`form-input ${formErrors.user_name ? 'input-error' : ''}`}
//                     value={form.user_name}
//                     onChange={(e) => {
//                       setForm({ ...form, user_name: e.target.value });

//                       if (formErrors.user_name) {
//                         setFormErrors((prev) => ({ ...prev, user_name: '' }));
//                       }
//                     }}

//                     placeholder="Name"
//                   />
//                   {formErrors.user_name && (
//                     <span className="error-text">{formErrors.user_name}</span>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <input
//                     className={`form-input ${formErrors.user_email ? 'input-error' : ''}`}
//                     value={form.user_email}
//                     onChange={(e) => {
//                       setForm({ ...form, user_email: e.target.value });

//                       if (formErrors.user_email) {
//                         setFormErrors((prev) => ({ ...prev, user_email: '' }));
//                       }
//                     }}
//                     placeholder="Email"
//                   />
//                   {formErrors.user_email && (
//                     <span className="error-text">{formErrors.user_email}</span>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <div style={{ position: 'relative', width: '100%' }}>
//                     <input
//                       type={showPassword ? "text" : "password"}
//                       className={`form-input ${formErrors.user_password ? 'input-error' : ''}`}
//                       // style={{ width: '100%', boxSizing: 'border-box', paddingRight: '40px' }}
//                       value={form.user_password}
//                       onChange={(e) => {
//                         const newPassword = e.target.value;
//                         setForm({ ...form, user_password: newPassword });
//                         checkPasswordStrength(newPassword);
//                         if (formErrors.user_password) {
//                           setFormErrors((prev) => ({ ...prev, user_password: '' }));
//                         }
//                       }}
//                       onFocus={() => setShowPasswordRules(true)}
//                       placeholder="Password"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowPassword(!showPassword)}
//                       style={{
//                         position: 'absolute',
//                         right: '10px',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         background: 'transparent',
//                         border: 'none',
//                         cursor: 'pointer',
//                         color: '#666',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         padding: 0
//                       }}
//                     >
//                       {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                     </button>
//                   </div>
//                   {formErrors.user_password && (
//                     <span className="error-text">{formErrors.user_password}</span>
//                   )}

//                   {/* Password Rules */}
//                   {showPasswordRules && (
//                     <div className="password-rules">
//                       <div className={`rule ${passwordChecks.length ? 'passed' : ''}`}>
//                         <span className="dot">
//                           {passwordChecks.length ? '✔' : ''}
//                         </span>
//                         password must have At least 8 characters
//                       </div>

//                       <div className={`rule ${passwordChecks.numbers ? 'passed' : ''}`}>
//                         <span className="dot">
//                           {passwordChecks.numbers ? '✔' : ''}
//                         </span>
//                         password must have At least 2 numbers
//                       </div>

//                       <div className={`rule ${passwordChecks.special ? 'passed' : ''}`}>
//                         <span className="dot">
//                           {passwordChecks.special ? '✔' : ''}
//                         </span>
//                         password must have At least 1 special character
//                       </div>
//                     </div>
//                   )}

//                 </div>




//                 <div className="form-group">
//                   <input
//                     className={`form-input ${formErrors.user_phone ? 'input-error' : ''}`}
//                     value={form.user_phone}
//                     onChange={(e) => {
//                       setForm({ ...form, user_phone: e.target.value });

//                       if (formErrors.user_phone) {
//                         setFormErrors((prev) => ({ ...prev, user_phone: '' }));
//                       }
//                     }}

//                     placeholder="Phone"
//                   />
//                   {formErrors.user_phone && (
//                     <span className="error-text">{formErrors.user_phone}</span>
//                   )}
//                 </div>

//                 <div className="form-group"
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px', // spacing between input and icon
//                   }}
//                 >
//                   <input
//                     className={`form-input ${formErrors.city ? 'input-error' : ''}`}
//                     value={form.city}
//                     onChange={(e) => {
//                       setForm({ ...form, city: e.target.value });

//                       if (formErrors.city) {
//                         setFormErrors((prev) => ({ ...prev, city: '' }));
//                       }
//                     }}

//                     placeholder="City or Village"
//                     style={{ flex: 1 }}
//                   />
//                   {/* <button
//                     type="button"
//                     onClick={handleLocationClick}
//                     title="Use current location"
//                     style={{
//                       // border: 'none',
//                       background: 'transparent',
//                       cursor: 'pointer',
//                       fontSize: 15,
//                       padding: '0px',
//                       // marginLeft: '-10px',
//                       lineHeight: '1',
//                       flexShrink: 10, // 👈 prevents button from shrinking input
//                       outline: 'none',
//                       boxShadow: 'none',
//                       marginRight: '-40px',
//                       color: 'black',
//                     }}
//                   >
//                     <img
//                       src={gps}
//                       alt="Use current location"
//                       style={{ width: '20px', height: '20px' }} />
//                   </button> */}
//                   {formErrors.city && (
//                     <span className="error-text">{formErrors.city}</span>
//                   )}
//                 </div>


//                 {form.user_role === 'lab' && (
//                   <div className="form-group">
//                     <input
//                       className={`form-input ${formErrors.gst_number ? 'input-error' : ''}`}
//                       value={form.gst_number}
//                       onChange={(e) => {
//                         setForm({ ...form, gst_number: e.target.value });

//                         if (formErrors.gst_number) {
//                           setFormErrors((prev) => ({ ...prev, gst_number: '' }));
//                         }
//                       }}

//                       placeholder="GST Number"
//                     />
//                     {formErrors.gst_number && (
//                       <span className="error-text">{formErrors.gst_number}</span>
//                     )}
//                   </div>
//                 )}
//               </div>
//             </>
//           )}

//           {/* Farmer Registration Form */}
//           {accountType === 'Animal Owner' && (
//             <>
//               <div className="form-grid">
//                 <div className="form-group">
//                   <input
//                     className={`form-input ${formErrors.owner_name ? 'input-error' : ''}`}
//                     value={form.owner_name}
//                     onChange={(e) => {
//                       setForm({ ...form, owner_name: e.target.value });

//                       if (formErrors.owner_name) {
//                         setFormErrors((prev) => ({ ...prev, owner_name: '' }));
//                       }
//                     }}

//                     placeholder="Name"
//                   />
//                   {formErrors.owner_name && (
//                     <span className="error-text">{formErrors.owner_name}</span>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <div style={{ position: 'relative', width: '100%' }}>
//                     <input
//                       className={`form-input ${formErrors.owner_password ? 'input-error' : ''}`}
//                       type={showPassword ? "text" : "password"}
//                       // style={{ width: '100%', boxSizing: 'border-box', paddingRight: '40px' }}
//                       value={form.owner_password}
//                       onChange={(e) => {
//                         setForm({ ...form, owner_password: e.target.value });

//                         if (formErrors.owner_password) {
//                           setFormErrors((prev) => ({ ...prev, owner_password: '' }));
//                         }
//                       }}

//                       placeholder="Password"
//                     />
//                     <button
//                       type="button"
//                       onClick={() => setShowPassword(!showPassword)}
//                       style={{
//                         position: 'absolute',
//                         right: '10px',
//                         top: '50%',
//                         transform: 'translateY(-50%)',
//                         background: 'transparent',
//                         border: 'none',
//                         cursor: 'pointer',
//                         color: '#666',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         padding: 0
//                       }}
//                     >
//                       {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
//                     </button>
//                   </div>
//                   {formErrors.owner_password && (
//                     <span className="error-text">{formErrors.owner_password}</span>
//                   )}
//                 </div>

//                 <div className="form-group">
//                   <input
//                     className={`form-input ${formErrors.owner_phone ? 'input-error' : ''}`}
//                     value={form.owner_phone}
//                     onChange={(e) => {
//                       setForm({ ...form, owner_phone: e.target.value });

//                       if (formErrors.owner_phone) {
//                         setFormErrors((prev) => ({ ...prev, owner_phone: '' }));
//                       }
//                     }}

//                     placeholder="Phone"
//                   />
//                   {formErrors.owner_phone && (
//                     <span className="error-text">{formErrors.owner_phone}</span>
//                   )}
//                 </div>

//                 <div className="form-group"
//                   style={{
//                     display: 'flex',
//                     alignItems: 'center',
//                     gap: '8px', // spacing between input and icon
//                   }}
//                 >
//                   <input
//                     className={`form-input ${formErrors.owner_city ? 'input-error' : ''}`}
//                     value={form.owner_city}
//                     onChange={(e) => {
//                       setForm({ ...form, owner_city: e.target.value });

//                       if (formErrors.owner_city) {
//                         setFormErrors((prev) => ({ ...prev, owner_city: '' }));
//                       }
//                     }}

//                     placeholder="City or Village"
//                     style={{ flex: 1 }}
//                   />
//                 </div>

//               </div>
//             </>
//           )}

//           <button className="form-button" onClick={handleRegister}>
//             Register
//           </button>

//           <div className="form-footer">
//             <p>
//               Already have an account? <Link to="/login">Login here</Link>
//             </p>
//           </div>


//         </div>
//       </div>
//     </>
//   );
// };

// export default Register;






import React, { useState } from 'react';
import api from '../../../api/axiosConfig';
import { Link, useNavigate } from 'react-router-dom';
import '../../../styles/forms.css';
import Navbar from '../homePage/Navbar';
import PersonIcon from '@mui/icons-material/Person';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import VaccinesIcon from '@mui/icons-material/Vaccines';
import BiotechIcon from '@mui/icons-material/Biotech';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import StorefrontIcon from '@mui/icons-material/Storefront';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import gps from '../../assets/gps.png'

const roles = ["lab"];
const EMAIL_PATTERN = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

const Register: React.FC = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [accountType, setAccountType] = useState<'Service' | 'Animal Owner'>('Animal Owner');
  const [toast, setToast] = useState<{ type: 'success' | 'error'; message: string } | null>(null);
  const [formErrors, setFormErrors] = useState<Record<string, string>>({});
  const [showPasswordRules, setShowPasswordRules] = useState(false);

  const [passwordChecks, setPasswordChecks] = useState({
    length: false,
    numbers: false,
    special: false
  });




  const initialFormState = {
    user_name: '',
    user_email: '',
    user_password: '',
    user_role: '',
    user_phone: '',
    city: '',
    govt_id_image: null as File | null,
    owner_name: '',
    owner_email: '',
    owner_password: '',
    owner_phone: '',
    owner_city: '',
    gst_number:''
  };

  const [form, setForm] = useState(initialFormState);




  const checkPasswordStrength = (password: string) => {
    const hasLength = password.length >= 8;
    const numberCount = (password.match(/\d/g) || []).length;
    const hasTwoNumbers = numberCount >= 2;
    const hasSpecial = /[!@#$%^&*(),.?":{}|<>]/.test(password);


    setPasswordChecks({
      length: hasLength,
      numbers: hasTwoNumbers,
      special: hasSpecial
    });

  };




  const validateForm = (): boolean => {
    const errors: Record<string, string> = {};

    if (accountType === 'Service') {
      if (!form.user_name?.trim()) errors.user_name = 'Name is required';
      if (!form.user_password?.trim()) errors.user_password = 'Password is required';
      if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(form.user_email)) errors.user_email = 'Invalid email format';
      if (!/^\d{10}$/.test(form.user_phone)) errors.user_phone = 'Phone Number must be a 10 digit number';
      if (!form.city?.trim()) errors.city = 'City is required';

      if (!passwordChecks.length || !passwordChecks.numbers || !passwordChecks.special) {
        errors.user_password = 'Password must satisfy all strength rules';
      }


      if (form.user_role === 'doctor') {
        if (!form.govt_id_image) errors.govt_id_image = 'Government ID image is required';
      }

    } else if (accountType === 'Animal Owner') {
      if (!form.owner_name?.trim()) errors.owner_name = 'Name is required';
      if (!EMAIL_PATTERN.test(form.owner_email.trim())) errors.owner_email = 'Invalid email format';
      if (!form.owner_password?.trim()) errors.owner_password = 'Password is required';
      else if (form.owner_password.length < 8) errors.owner_password = 'Password must be 8 or more characters';
      if (!/^\d{10}$/.test(form.owner_phone)) errors.owner_phone = 'Phone must be a 10 digit number';
      if (!form.owner_city?.trim()) errors.owner_city = 'City is required';
    }

    setFormErrors(errors);

    return Object.keys(errors).length === 0;
  };


  const handleRegister = async () => {
    try {
      const isValid = validateForm();
      if (!isValid) return;

      if (accountType === 'Service') {
        const formData = new FormData();
        Object.entries(form).forEach(([key, value]) => {
          if (
            value !== null &&
            (
              key.startsWith('user_') ||
              ['govt_id', 'specialization', 'gst_number', 'govt_id_image', 'city',].includes(key)
            )
          ) {
            formData.append(key, value as string | Blob);
          }
        });

        await api.auth_api.post('/auth/register', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        setToast({ type: 'success', message: 'Registered successfully!' });
        setTimeout(() => navigate('/login'), 1500);
      } else {
        await api.auth_api.post('/auth/registerAnimal', {
          owner_name: form.owner_name.trim(),
          owner_email: form.owner_email.trim().toLowerCase(),
          owner_password: form.owner_password,
          owner_phone: form.owner_phone.trim(),
          owner_city: form.owner_city.trim(),
          owner_role: 'owner'
        });

        setToast({ type: 'success', message: 'owner Registered!' });
        setTimeout(() => navigate('/login'), 1500);
      }

      setForm(initialFormState);
      setShowPasswordRules(false);
      setPasswordChecks({
        length: false,
        numbers: false,
        special: false
      });
    } catch (error: any) {
      setToast({
        type: 'error',
        message: error?.response?.data?.message || 'Registration failed. Please try again.'
      });
    } finally {
      setTimeout(() => setToast(null), 5000); // auto-close after 5s
    }
  };
  

  const handleLocationClick = () => {
  if (!navigator.geolocation) {
    alert("Geolocation is not supported by your browser.");
    return;
  }

  navigator.geolocation.getCurrentPosition(
    async (position) => {
      const { latitude, longitude } = position.coords;
      try {
        const res = await fetch(
          `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
        );
        const data = await res.json();
        const address = data.address;

        if (accountType === "Animal Owner") {
          setForm((prev) => ({
            ...prev,
            city: address.city || address.town || address.village || "",
          }));
        } else {
          setForm((prev) => ({
            ...prev,
            owner_city: address.city || address.town || address.village || "",
          }));
        }
      } catch (err) {
        console.error("Reverse geocoding failed:", err);
        alert("Could not retrieve location details.");
      }
    },
    (err) => {
      console.error("Geolocation error:", err);
      alert("Permission denied or location unavailable.");
    }
  );
};








  return (
    <>
      {/* <TopBar /> */}
      <Navbar />

      {toast && (
        <div className={`global-toast ${toast.type}`}>
          <span>{toast.message}</span>
          <button
            className="toast-close"
            onClick={() => setToast(null)}
            aria-label="Close"
          >
            ×
          </button>
        </div>
      )}

      <div className="center-page-lr">
        <div className="form-container">
          <h2 className="form-title">Register</h2>

          {/* Account Type Selection */}
          <div className="form-group animated-toggle">
            {['Animal Owner', 'Service'].map((type) => (
              <div
                key={type}
                className={`toggle-tile ${accountType === type ? 'active' : ''}`}
                onClick={() => setAccountType(type as 'Service' | 'Animal Owner')}
              >
                {type === 'Service' ? 'Service' : 'Animal Owner'}
              </div>
            ))}
          </div>





          {/* User Registration Form */}
          {accountType === 'Service' && (
            <>
              {/* Role Selection */}
              <div className="form-group creative-role-grid">
                {roles.map((role) => (
                  <div
                    key={role}
                    className={`creative-card ${form.user_role === role ? 'active' : ''}`}
                    onClick={() => setForm({ ...form, user_role: role })}
                  >
                    <div className="creative-icon">
                      {role === "doctor" ? (
                        <PersonIcon />
                      ) : role === "hospital" ? (
                        <LocalHospitalIcon />
                      ) : role === "pharmacy" ? (
                        <VaccinesIcon />
                      ) : role === "lab" ? (
                        <BiotechIcon />
                      ) : role === "organisation" ? (
                        <CorporateFareIcon />
                      ) : role === "vendor" ? (
                        <StorefrontIcon />
                      ) : (
                        <PersonIcon />
                      )}
                    </div>
                    &nbsp;
                    &nbsp;
                    <span>{role.charAt(0).toUpperCase() + role.slice(1)}</span>
                  </div>
                ))}
              </div>

              <div className="form-grid">
                <div className="form-group">
                  <input
                    className={`form-input ${formErrors.user_name ? 'input-error' : ''}`}
                    value={form.user_name}
                    onChange={(e) => {
                      setForm({ ...form, user_name: e.target.value });

                      if (formErrors.user_name) {
                        setFormErrors((prev) => ({ ...prev, user_name: '' }));
                      }
                    }}

                    placeholder="Name"
                  />
                  {formErrors.user_name && (
                    <span className="error-text">{formErrors.user_name}</span>
                  )}
                </div>

                <div className="form-group">
                  <input
                    className={`form-input ${formErrors.user_email ? 'input-error' : ''}`}
                    value={form.user_email}
                    onChange={(e) => {
                      setForm({ ...form, user_email: e.target.value });

                      if (formErrors.user_email) {
                        setFormErrors((prev) => ({ ...prev, user_email: '' }));
                      }
                    }}
                    placeholder="Email"
                  />
                  {formErrors.user_email && (
                    <span className="error-text">{formErrors.user_email}</span>
                  )}
                </div>

                <div className="form-group">
                  <div style={{ position: 'relative', width: '100%' }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      className={`form-input ${formErrors.user_password ? 'input-error' : ''}`}
                      value={form.user_password}
                      onChange={(e) => {
                        const newPassword = e.target.value;
                        setForm({ ...form, user_password: newPassword });
                        checkPasswordStrength(newPassword);
                        if (formErrors.user_password) {
                          setFormErrors((prev) => ({ ...prev, user_password: '' }));
                        }
                      }}
                      onFocus={() => setShowPasswordRules(true)}
                      placeholder="Password"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#666',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 0
                      }}
                    >
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </button>
                  </div>
                  {formErrors.user_password && (
                    <span className="error-text">{formErrors.user_password}</span>
                  )}

                  {/* Password Rules */}
                  {showPasswordRules && (
                    <div className="password-rules">
                      <div className={`rule ${passwordChecks.length ? 'passed' : ''}`}>
                        <span className="dot">
                          {passwordChecks.length ? '✔' : ''}
                        </span>
                        password must have At least 8 characters
                      </div>

                      <div className={`rule ${passwordChecks.numbers ? 'passed' : ''}`}>
                        <span className="dot">
                          {passwordChecks.numbers ? '✔' : ''}
                        </span>
                        password must have At least 2 numbers
                      </div>

                      <div className={`rule ${passwordChecks.special ? 'passed' : ''}`}>
                        <span className="dot">
                          {passwordChecks.special ? '✔' : ''}
                        </span>
                        password must have At least 1 special character
                      </div>
                    </div>
                  )}

                </div>




                <div className="form-group">
                  <input
                    className={`form-input ${formErrors.user_phone ? 'input-error' : ''}`}
                    value={form.user_phone}
                    onChange={(e) => {
                      setForm({ ...form, user_phone: e.target.value });

                      if (formErrors.user_phone) {
                        setFormErrors((prev) => ({ ...prev, user_phone: '' }));
                      }
                    }}

                    placeholder="Phone"
                  />
                  {formErrors.user_phone && (
                    <span className="error-text">{formErrors.user_phone}</span>
                  )}
                </div>

                <div className="form-group"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px', // spacing between input and icon
                  }}
                >
                  <input
                    className={`form-input ${formErrors.city ? 'input-error' : ''}`}
                    value={form.city}
                    onChange={(e) => {
                      setForm({ ...form, city: e.target.value });

                      if (formErrors.city) {
                        setFormErrors((prev) => ({ ...prev, city: '' }));
                      }
                    }}

                    placeholder="City or Village"
                    style={{ flex: 1 }}
                  />
                  {/* <button
                    type="button"
                    onClick={handleLocationClick}
                    title="Use current location"
                    style={{
                      background: 'transparent',
                      cursor: 'pointer',
                      fontSize: 15,
                      padding: '0px',
                      lineHeight: '1',
                      flexShrink: 10, // 👈 prevents button from shrinking input
                      outline: 'none',
                      boxShadow: 'none',
                      marginRight: '-40px',
                      color: 'black',
                    }}
                  >
                    <img
                      src={gps}
                      alt="Use current location"
                      style={{ width: '20px', height: '20px' }} />
                  </button> */}
                  {formErrors.city && (
                    <span className="error-text">{formErrors.city}</span>
                  )}
                </div>


                {form.user_role === 'lab' && (
                  <div className="form-group">
                    <input
                      className={`form-input ${formErrors.gst_number ? 'input-error' : ''}`}
                      value={form.gst_number}
                      onChange={(e) => {
                        setForm({ ...form, gst_number: e.target.value });

                        if (formErrors.gst_number) {
                          setFormErrors((prev) => ({ ...prev, gst_number: '' }));
                        }
                      }}

                      placeholder="GST Number"
                    />
                    {formErrors.gst_number && (
                      <span className="error-text">{formErrors.gst_number}</span>
                    )}
                  </div>
                )}
              </div>
            </>
          )}

          {/* Farmer Registration Form */}
          {accountType === 'Animal Owner' && (
            <>
              <div className="form-grid">
                <div className="form-group">
                  <input
                    className={`form-input ${formErrors.owner_name ? 'input-error' : ''}`}
                    value={form.owner_name}
                    onChange={(e) => {
                      setForm({ ...form, owner_name: e.target.value });

                      if (formErrors.owner_name) {
                        setFormErrors((prev) => ({ ...prev, owner_name: '' }));
                      }
                    }}

                    placeholder="Name"
                  />
                  {formErrors.owner_name && (
                    <span className="error-text">{formErrors.owner_name}</span>
                  )}
                </div>

                <div className="form-group">
                  <input
                    type="email"
                    className={`form-input ${formErrors.owner_email ? 'input-error' : ''}`}
                    value={form.owner_email}
                    onChange={(e) => {
                      setForm({ ...form, owner_email: e.target.value });

                      if (formErrors.owner_email) {
                        setFormErrors((prev) => ({ ...prev, owner_email: '' }));
                      }
                    }}
                    placeholder="Email"
                    autoComplete="email"
                  />
                  {formErrors.owner_email && (
                    <span className="error-text">{formErrors.owner_email}</span>
                  )}
                </div>

                <div className="form-group">
                  <div style={{ position: 'relative', width: '100%' }}>
                    <input
                      className={`form-input ${formErrors.owner_password ? 'input-error' : ''}`}
                      type={showPassword ? "text" : "password"}
                      value={form.owner_password}
                      onChange={(e) => {
                        setForm({ ...form, owner_password: e.target.value });

                        if (formErrors.owner_password) {
                          setFormErrors((prev) => ({ ...prev, owner_password: '' }));
                        }
                      }}

                      placeholder="Password"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: 'absolute',
                        right: '10px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        background: 'transparent',
                        border: 'none',
                        cursor: 'pointer',
                        color: '#666',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 0
                      }}
                    >
                      {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                    </button>
                  </div>
                  {formErrors.owner_password && (
                    <span className="error-text">{formErrors.owner_password}</span>
                  )}
                </div>

                <div className="form-group">
                  <input
                    className={`form-input ${formErrors.owner_phone ? 'input-error' : ''}`}
                    value={form.owner_phone}
                    onChange={(e) => {
                      setForm({ ...form, owner_phone: e.target.value });

                      if (formErrors.owner_phone) {
                        setFormErrors((prev) => ({ ...prev, owner_phone: '' }));
                      }
                    }}

                    placeholder="Phone"
                  />
                  {formErrors.owner_phone && (
                    <span className="error-text">{formErrors.owner_phone}</span>
                  )}
                </div>

                <div className="form-group"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px', // spacing between input and icon
                  }}
                >
                  <input
                    className={`form-input ${formErrors.owner_city ? 'input-error' : ''}`}
                    value={form.owner_city}
                    onChange={(e) => {
                      setForm({ ...form, owner_city: e.target.value });

                      if (formErrors.owner_city) {
                        setFormErrors((prev) => ({ ...prev, owner_city: '' }));
                      }
                    }}

                    placeholder="City or Village"
                    style={{ flex: 1 }}
                  />
                </div>

              </div>
            </>
          )}

          <button className="form-button" onClick={handleRegister}>
            Register
          </button>

          <div className="form-footer">
            <p>
              Already have an account? <Link to="/login">Login here</Link>
            </p>
          </div>


        </div>
      </div>
    </>
  );
};

export default Register;
